// extracted by mini-css-extract-plugin
module.exports = {"container":"_26Wj7SrxKNBI0rwkdkvZ3L","event-text":"_1HUe2XsTcVB-v4uY5438ka","widget":"_3fkzDkeLHVJGtq30e4uc1R"};